import { inject, Injectable } from '@angular/core';
import { MAX_SIZE_20_MB } from '../consts/size.consts';
import { ToastService } from './toast.service';
import { LocaleService } from './locale.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  localeService = inject(LocaleService);
  toastService = inject(ToastService);

  checkMaxSizeExceeded($event: Event, maxSize: number = MAX_SIZE_20_MB) {
    const input = $event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      this.toastService.openErrorToast('default_upload_file_error');
      return true;
    }

    if (file?.size > maxSize) {
      input.value = '';
      const message = this.localeService.getString('default_size_limit_exceeded').replace('__MAX_SIZE__', `${maxSize / 1_000_000}`);
      this.toastService.openErrorToast(message);
      return true;
    }
    return false;
  }
}
